<mat-list [formGroup]="antennasFormGroup">
  <mat-list-item>
    <mat-checkbox [formControl]="formControls.getterAntenna"
      >Vevőantennák</mat-checkbox
    ></mat-list-item
  >
  <mat-list-item>
    <mat-checkbox [formControl]="formControls.selfAntenna"
      >Saját antennák</mat-checkbox
    ></mat-list-item
  >
</mat-list>
